const generateForm10 = [
  {
    label: "จำนวนเงินเดือน", // i18n-ignore (translated at render site)
    name: "salary_amount",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "คู่สมรส", // i18n-ignore (translated at render site)
    name: "spouse",
    // แสดงรวมกับนามสกุลคู่สมรส (อ่านอย่างเดียว) แต่ตอน save แยกเก็บ spouse / spouse_last_name
    concatWith: "spouse_last_name",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: true,
    section: "information",
  },
  {
    label: "ตำแหน่ง", // i18n-ignore (translated at render site)
    name: "position_name",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "สังกัด", // i18n-ignore (translated at render site)
    name: "affiliation_name",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "แผนงาน", // i18n-ignore (translated at render site)
    name: "department_name",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ประเทศ", // i18n-ignore (translated at render site)
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "มีกำหนด (ปี)", // i18n-ignore (translated at render site)
    name: "scheduled_year",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "มีมีกำหนด (เดือน)", // i18n-ignore (translated at render site)
    name: "scheduled_month",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "มีกำหนด (วัน)", // i18n-ignore (translated at render site)
    name: "scheduled_day",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ตั้งแต่วันที่", // i18n-ignore (translated at render site)
    name: "start_date",
    placeholder: "",
    type: "date",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ถึงวันที่", // i18n-ignore (translated at render site)
    name: "end_date",
    placeholder: "",
    type: "date",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
];

export default generateForm10;
